import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { Collapse, Row, Col, Button, message } from 'antd';
import { connect } from 'react-redux';

import { Form, Field } from 'react-final-form';

import { TextField } from '../../atoms';
import { ClassificatorField } from '../../atoms/reduxForms';
import {
  loadingUnitFilterFields,
  LOADING_UNIT_FILTER_FORM,
} from '../../constants/loadingUnit';
import { FormActions } from '../../components';
import { parseNumber } from '../../utils/formHelpers';
import { searchLoadingUnits } from '../../actions/actionCreators/loadingUnitActionCreator';
import { updateFormState } from '../../reducers/reactFinalFormReducer';
import FormStateToRedux from '../FormStateToRedux';

const { Panel } = Collapse;

export class LoadingUnitFilter extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    searchLoadingUnits: PropTypes.func.isRequired,
    isAdmin: PropTypes.bool.isRequired,
    updateFormState: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.props.updateFormState(LOADING_UNIT_FILTER_FORM, { values: {} });
    this.props.searchLoadingUnits();
  }

  onClear = (form) => {
    form.restart({});
    this.props.updateFormState(LOADING_UNIT_FILTER_FORM, { values: {} });
    this.props.searchLoadingUnits();
  };

  onSubmit = (values) => {
    const { t } = this.props;

    const allEmpty = Object.values(values || {}).every((v) => isEmpty(v));
    if (allEmpty) {
      message.error(t('shouldFillAnyFilter'));
      return;
    }

    this.props.searchLoadingUnits();
  };

  render() {
    const { t, isAdmin } = this.props;

    return (
      <div>
        <div className="search-form-container">
          <Collapse>
            <Panel key="filters" header={t('filter.title')}>
              <Form
                initialValues={{}}
                onSubmit={this.onSubmit}
                render={({ handleSubmit, form }) => (
                  <form onSubmit={handleSubmit}>
                    <FormStateToRedux form={LOADING_UNIT_FILTER_FORM} />

                    <Row gutter={32}>
                      <Col span={8}>
                        <Field
                          label={t('filter.name')}
                          name={loadingUnitFilterFields.NAME}
                          component={TextField}
                          hasFeedback={false}
                        />
                      </Col>

                      {isAdmin && (
                        <Col span={8}>
                          <Field
                            label={t('filter.registerCode')}
                            name={loadingUnitFilterFields.REGISTER_CODE}
                            component={TextField}
                            parse={parseNumber}
                            hasFeedback={false}
                          />
                        </Col>
                      )}

                      {isAdmin && (
                        <Col span={8}>
                          <Field
                            label={t('filter.status')}
                            name={loadingUnitFilterFields.STATUS}
                            component={ClassificatorField}
                            classificatorType={
                              ClassificatorField.types.loadingUnitStatus
                            }
                            hasFeedback={false}
                          />
                        </Col>
                      )}

                      {!isAdmin && (
                        <Col span={8}>
                          <Field
                            label={t('filter.marker')}
                            name={loadingUnitFilterFields.MODEL}
                            component={TextField}
                            hasFeedback={false}
                          />
                        </Col>
                      )}
                    </Row>

                    <FormActions>
                      <Button onClick={() => this.onClear(form)}>
                        {t('filter.clearBtn')}
                      </Button>
                      <Button type="primary" htmlType="submit">
                        {t('filter.submitBtn')}
                      </Button>
                    </FormActions>
                  </form>
                )}
              />
            </Panel>
          </Collapse>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = {
  searchLoadingUnits,
  updateFormState,
};

export default connect(null, mapDispatchToProps)(LoadingUnitFilter);
